module.exports = __webpack_public_path__ + "static/media/layout3.ab906a35.png";